// JavaScript Document
// Version: 1.2.0

var textEditorItems = [];



jQuery(document).ready(function($) {
	var imprintMainCtx = getImprintMainCtx();

	/**
	 * Gestisce l'inserimento del testo all'interno delle aree di stampa.
	 *
	 * @since 1.0.0
	 */
	imprintMainCtx.on('click', '.btnUpdateText', function() {
		var that         = $(this);
		var ctx          = getPrintAreaParentTabCtx(that);
		var areaId       = ctx.data('area-id');
		var componentId  = getPrintAreaAncestorTabCtx(that).attr('data-component-id');

		updateTextCanvas(that);

		// Nel momento in cui cambia la configurazione della penna non c'è più ragione di mostrare il link alle configurazioni salvate.
		$('#saved-configurations-container').fadeOut();
	});



	/**
	 * Gestisce la selezione del tipo di font.
	 *
	 * @since 1.0.0
	 */
	imprintMainCtx.on('change', 'select.font-family', function() {
		var that                       = $(this);
		var tabCtx                     = getPrintAreaTabCtx(that);
		var areaId                     = tabCtx.data('area-id');
		var previewPrintAreaCtx        = getPreviewPrintAreaCtxByDataAttribute([
			{
				dataAttribute: 'area-id',
				attributeValue: areaId,
				dataRelation: '='
			}
		]);
		var previewPrintAreaContentCtx = getPreviewPrintAreaContentCtx(previewPrintAreaCtx);

		if ( previewPrintAreaContentCtx.length > 0 ) {
			updateTextCanvas(that);
		}

	});



	/**
	 * Gestisce la selezione della dimensione del testo.
	 *
	 * @since 1.0.0
	 */
	imprintMainCtx.on('change', 'select.font-size', function() {
		var that                       = $(this);
		var tabCtx                     = getPrintAreaTabCtx(that);
		var areaId                     = tabCtx.data('area-id');
		var previewPrintAreaCtx        = getPreviewPrintAreaCtxByDataAttribute([
			{
				dataAttribute: 'area-id',
				attributeValue: areaId,
				dataRelation: '='
			}
		]);
		var previewPrintAreaContentCtx = getPreviewPrintAreaContentCtx(previewPrintAreaCtx);

		if ( previewPrintAreaContentCtx.length > 0 ) {
			updateTextCanvas(that);
		}

	});



	/**
	 * Gestisce la selezione dello stile del testo.
	 *
	 * @since 1.1.0
	 */
	$('.btnBold input[type="checkbox"]').on('change', function() {
		var that                       = $(this);
		var tabCtx                     = getPrintAreaParentTabCtx(that);
		var areaId                     = tabCtx.data('area-id');
		var previewPrintAreaCtx        = getPreviewPrintAreaCtxByDataAttribute([
			{
				dataAttribute: 'area-id',
				attributeValue: areaId,
				dataRelation: '='
			}
		]);
		var previewPrintAreaContentCtx = getPreviewPrintAreaContentCtx(previewPrintAreaCtx);
		var fontWeight                 = that.prop('checked') ? 'bold' : 'normal';

		if ( previewPrintAreaContentCtx.length > 0 ) {
			updateTextCanvas(that);
		}

		that.focusout();
	});

	$('.btnItalic input[type="checkbox"]').on('change', function() {
		var that                       = $(this);
		var tabCtx                     = getPrintAreaParentTabCtx(that);
		var areaId                     = tabCtx.data('area-id');
		var previewPrintAreaCtx        = getPreviewPrintAreaCtxByDataAttribute([
			{
				dataAttribute: 'area-id',
				attributeValue: areaId,
				dataRelation: '='
			}
		]);
		var previewPrintAreaContentCtx = getPreviewPrintAreaContentCtx(previewPrintAreaCtx);
		var fontStyle                  = that.prop('checked') ? 'italic' : 'normal';

		if ( previewPrintAreaContentCtx.length > 0 ) {
			updateTextCanvas(that);
		}

		that.focusout();
	});



	/**
	 * Gestisce la selezione dell'allineamento del testo.
	 *
	 * @since 1.1.0
	 */
	$('.btnTextAlign input[type="radio"]').on('change', function() {
		var that                       = $(this);
		var buttonGroupCtx             = that.closest('.btn-group');
		var tabCtx                     = getPrintAreaParentTabCtx(that);
		var areaId                     = tabCtx.data('area-id');
		var previewPrintAreaCtx        = getPreviewPrintAreaCtxByDataAttribute([
			{
				dataAttribute: 'area-id',
				attributeValue: areaId,
				dataRelation: '='
			}
		]);
		var previewPrintAreaContentCtx = getPreviewPrintAreaContentCtx(previewPrintAreaCtx);
		var textAlign                  = $('input[type="radio"]:checked', buttonGroupCtx).attr('id');

		if ( previewPrintAreaContentCtx.length > 0 ) {
			updateTextCanvas(that);
		}
	});



	/**
	 * Gestisce la rotazione del testo.
	 * La rotazione permette di definire unicamente l'orientamento del testo per mancini o destrimani.
	 * Il testo si sviluppa soltanto lungo l'asse della penna.
	 *
	 * @since 1.1.0
	 */
	$('.text-editor .btnRotate').on('click', function() {

		var that                       = $(this);
		var tabCtx                     = getPrintAreaParentTabCtx(that);
		var areaId                     = tabCtx.data('area-id');
		var previewPrintAreaCtx        = getPreviewPrintAreaCtxByDataAttribute([
			{
				dataAttribute: 'area-id',
				attributeValue: areaId,
				dataRelation: '='
			}
		]);
		var previewPrintAreaContentCtx = getPreviewPrintAreaContentCtx(previewPrintAreaCtx);
		var angle                      = parseInt(that.data('deg'));
		var newAngle                   = ( angle == 270 ) ? 90 : 270;
		// Per gestire rotazioni del testo di 90 gradi anziché 180.
		//var newAngle                   = ( angle + 90 > 360 ) ? 90 : angle + 90;

		that.data('deg', newAngle);


		if ( previewPrintAreaContentCtx.length > 0 ) {
			updateTextCanvas(that);
		}

		that.focusout();

	});



	/**
	 * Gestisce il colore del testo.
	 *
	 * @since 1.0.0
	 */
	$('.btnFontColor').on('click', function() {
		var that = $(this);
		var ctx  = $(this).closest('.font-color');

		that.toggleClass('active');
		$('.colors-list[data-visible="true"]', ctx).toggleClass('open');
	});

	$('body').on('click', '.font-color .colors-list li', function(e) {
		var that                       = $(this);
		var containerCtx               = that.closest('.font-color');
		var tabCtx                     = getPrintAreaParentTabCtx(that);
		var color                      = $('.selection span', that).css('background-color');
		var colorHexCode               = $('.selection span', that).attr('data-color-hexcode');
		var colorLabel                 = $('.selection span', that).attr('data-original-title');
		var areaId                     = tabCtx.data('area-id');
		var previewPrintAreaCtx        = getPreviewPrintAreaCtxByDataAttribute([
			{
				dataAttribute: 'area-id',
				attributeValue: areaId,
				dataRelation: '='
			}
		]);
		var previewPrintAreaContentCtx = getPreviewPrintAreaContentCtx(previewPrintAreaCtx);

		$('.colors-list li.active', tabCtx).removeClass('active');
		that.addClass('active');

		that.parent().removeClass('open');
		$('.btnFontColor', containerCtx).removeClass('active');
		$('.font-color', tabCtx).attr('data-color-hexcode', colorHexCode).attr('data-color-label', colorLabel);

		if ( previewPrintAreaContentCtx.length > 0 ) {
			updateTextCanvas(that);
    	}
	});



	/**
	 * Gestisce la rimozione del testo all'interno delle aree di stampa.
	 *
	 * @since 1.0.0
	 */
	imprintMainCtx.on('click', '.btnCancelText', function() {
		var that                       = $(this);
		var tabCtx                     = getPrintAreaParentTabCtx(that);
		var areaId                     = tabCtx.data('area-id');
		var previewPrintAreaCtx        = getPreviewPrintAreaCtxByDataAttribute([
			{
				dataAttribute: 'area-id',
				attributeValue: areaId,
				dataRelation: '='
			}
		]);
		var previewPrintAreaContentCtx = getPreviewPrintAreaContentCtx(previewPrintAreaCtx);

		removeImage(areaId, 'text-multiline');
		$('textarea', tabCtx).val('').focus();
		updateTextCanvas(that);

		// Nel momento in cui cambia la configurazione della penna non c'è più ragione di mostrare il link alle configurazioni salvate.
		$('#saved-configurations-container').fadeOut();
	});



	/**
	 * Gestisce la selezione della proprietà text-transform del testo.
	 *
	 * @since 1.0.0
	 */
	imprintMainCtx.on('click', '.text-transform', function() {
		var that                       = $(this);
		var tabCtx                     = getPrintAreaParentTabCtx(that);
		var areaId                     = tabCtx.data('area-id');
		var previewPrintAreaCtx        = getPreviewPrintAreaCtxByDataAttribute([
			{
				dataAttribute: 'area-id',
				attributeValue: areaId,
				dataRelation: '='
			}
		]);
		var previewPrintAreaContentCtx = getPreviewPrintAreaContentCtx(previewPrintAreaCtx);
		var transform                  = $('.pressed input[type="radio"]', that).attr('id');

		// Nel caso sia stato inserito un testo tutto in maiuscolo, la regola CSS "text-transform: capitalize;" non funziona.
		// E' necessario trasformare il testo in minuscolo, mantenendo al contempo memorizzato il testo originale, da ripristinare qunado necessario.
		var span                      = $('span', previewPrintAreaContentCtx)[0];

		if ( 'capitalize' == transform ) {
			if ( $(span).length > 0 ) {
				var currentText = $(span).text();

				if ( currentText === currentText.toUpperCase() ) {
					// Salvo il testo originale.
					if ( !is_defined( $(span).attr('data-original') ) ) {
						$(span).attr('data-original', currentText);
					}

					// Trasformo il testo in minuscolo.
					$(span).text(currentText.toLowerCase());
				}
			}
		} else {
			if ( is_defined( $(span).attr('data-original') ) ) {
				// Ripristino il testo originale prima di applicare altre trasformazioni.
				$(span).text($(span).attr('data-original'));
			}
		}

		if ( previewPrintAreaContentCtx.length > 0 ) {
			updateTextCanvas(that);
		}
	});

});





/**
 * Aggiorna il canvas per effettuare il rendering del testo nelle preview.
 *
 * @param {selector} triggerElement :
 *
 * @since 1.2.0
 */
function updateTextCanvas(triggerElement) {
	var ctx          = getPrintAreaParentTabCtx(triggerElement);
	var areaId       = ctx.data('area-id');
	var text         = jQuery('textarea', ctx).val();
	var fontFamily   = jQuery('select.font-family', ctx).val();
	var fontSize     = jQuery('select.font-size', ctx).val();
	var fontWeight   = ( jQuery('.btnBold .btn', ctx).hasClass('active') ) ? 'bold' : 'normal';
	var fontStyle    = ( jQuery('.btnItalic .btn', ctx).hasClass('active') ) ? 'italic' : 'normal';
	var fontColor    = '#' + jQuery('.font-color', ctx).attr('data-color-hexcode');
	var lineHeight   = 1.05;
	var textAlign    = jQuery('.btnTextAlign .active input[type="radio"]', ctx).attr('id');
	var textRotation = jQuery('.btnRotate', ctx).data('deg');//jQuery('.text-rotate', ctx).data('deg');

	if ( '' != text ) {
		printAreaContentInfo[areaId] = {
			text: text,
			fontFamily: fontFamily,
			fontSize: fontSize + 'px',
			lineHeight: lineHeight,
			fontWeight: fontWeight,
			fontStyle: fontStyle,
			textAlign: textAlign,
			color: fontColor,
			textRotation: textRotation
		};

	} else {
		printAreaContentInfo[areaId] = {};
	}

	var printAreaObj   = {
		id: ctx.attr('data-area-id'),
		width: ctx.attr('data-area-width'),
		height: ctx.attr('data-area-height'),
		//left: jQuery('canvas', context).width() / 2 - ctx.attr('data-area-width') / 2,
		//top: jQuery('canvas', context).height() / 2 - ctx.attr('data-area-height') / 2
	};
	var hiImageHeight  = minerva_configurator_vars.hi_image_height;
	var lowImageHeight = minerva_configurator_vars.low_image_height;
	var cf             = hiImageHeight / lowImageHeight;

	if ( textEditorItems[areaId] == null ) {
		var hiresCanvas = new fabric.Canvas(jQuery('canvas.hires-canvas', ctx).attr('id'));

		hiresCanvas.setDimensions({
			width: printAreaObj.width * cf,
			height: printAreaObj.height * cf
		});

		textEditorItems[areaId] = { 'hiresCanvas': hiresCanvas, 'printArea': printAreaObj };
	}
	else {
		textEditorItems[areaId].hiresCanvas.clear();
	}

	var textbox = new fabric.Textbox(text, {
		width: printAreaObj.height * cf,
		angle: textRotation,
		fontSize: fontSize * cf,
		fontWeight: fontWeight,
		fontStyle: fontStyle,
		fontFamily: fontFamily,
		lineHeight: lineHeight,
		fill: fontColor,
		textAlign: textAlign
	});

	var textTop    = 0;
	var textLeft   = 0;
	var textHeight = textbox.calcTextHeight();

	if (textRotation > 180) {
		textTop  = printAreaObj.height * cf;
		textLeft = (printAreaObj.width * cf / 2) - (textHeight / 2);
	}else {
		textLeft = (printAreaObj.width * cf / 2) + (textHeight / 2);
		textTop  = 0;
	}

	textbox.set("top", textTop);
	textbox.set("left", textLeft);
	textEditorItems[areaId].hiresCanvas.add(textbox);
	textEditorItems[areaId].hiresCanvas.renderAll();

	var imageBytes         = textEditorItems[areaId].hiresCanvas.toDataURL({
		left: 0,
		top: 0,
		width: textEditorItems[areaId].hiresCanvas.width,
		height: textEditorItems[areaId].hiresCanvas.height
	});

	var activeImprintPanel = ctx.closest('.imprint-panel.in');

	appendImage(ctx.attr('data-area-id'), imageBytes, 'text-multiline');
}



/* VIENE MANTENUTA PER RETROCOMPATIBILITA' */
/**
 * Aggiunge il testo all'area di stampa.
 *
 * @param {string} areaId       : ID dell'area di stanpa
 * @param {string} text         : testo
 * @param {string} fontFamily   : attributo font-family
 * @param {string} fontSize     : dimensione del testo (in px)
 * @param {string} fontWeight   : attributo font-weight
 * @param {string} fontStyle    : attributo font-style
 * @param {string} fontColor    : codice esadecimale del colore del testo (è presente il simbolo #)
 * @param {string} textAlign    : attributo text-align
 * @param {string} textRotation : angolo di rotazione del testo
 * @param {string} componentId  : ID del componente
 * @param {string} type         : tipo di controllo (input o textarea)
 *
 * @since 1.0.0
 */
function appendText(areaId, text, fontFamily, fontSize, fontWeight, fontStyle, fontColor, textAlign, textRotation, componentId, type) {
	jQuery('.print-area[data-area-id="' + areaId + '"]').each(function(index, element) {
		var that                = jQuery(this);
		var printAreaWidth      = that.css('width');
		var printAreaHeight     = that.css('height');
		var containerWidth      = printAreaHeight;
		var containerHeight     = printAreaWidth;
		var containerLeftOffset = '50%';
		var containerTopOffset  = '50%';
		var containerMarginTop  = parseFloat(containerHeight.replace(/[^-\d\.]/g, '')) / -2;
		var lineHeight          = ( 'input' == type ) ? containerHeight : 'normal';
		var attr                = that.attr('data-image-shift');
		var imageShift          = ( typeof attr !== typeof undefined && attr !== false ) ? parseFloat(attr) : 0;
		// ATTENZIONE: la disposizione verticale del testo NON inverte altezza e larghezza.
		// Bisogna sempre considerare il testo come orizzontale quando si opera con i valori di width ed height.
		var containerMarginLeft = parseFloat(containerWidth.replace(/[^-\d\.]/g, '')) / -2 + imageShift;
		var absoluteAttributes;
		var view                = that.closest('.view').attr('data-view-code');

		switch ( textAlign ) {
			case 'left':
				absoluteAttributes = 'left:0; top:50%; transform:translateY(-50%);';
				break;
			case 'center':
				absoluteAttributes = 'left:50%; top:50%; transform:translateY(-50%) translateX(-50%);';
				break;
			case 'right':
				absoluteAttributes = 'right:0; top:50%; transform:translateY(-50%);';
				break;
		}

		var content          = '';

		// Verifico se esistono più aree di stampa esclusive.
		// Se viene inserito del testo in una di esse, il testo inserito in precedenza su una delle altre deve essere rimosso.
		var searchCtx        = jQuery('div[data-view-code="' + view + '"]', getPreviewCtx());
		var searchPreviewCtx = getPreviewPrintAreaCtxByDataAttribute([
			{
				dataAttribute: 'area-id',
				attributeValue: areaId,
				dataRelation: '!='
			},
			{
				dataAttribute: 'component-id',
				attributeValue: componentId,
				dataRelation: '='
			}
		], searchCtx);

		searchPreviewCtx.each(function(i, el) {
			var printArea   = jQuery(el);
			var printAreaId = printArea.attr('data-area-id');

			if ( collision(that, printArea) ) {
				getPreviewPrintAreaContentCtx(printArea).remove();
			}
		});

		if ( '' != text ) {
			content += '<div data-area-id="' + areaId + '" class="print-area-content" style="position:absolute; z-index:201; transform:rotateZ(' + textRotation + 'deg); -webkit-transform:rotateZ(' + textRotation + 'deg); width:' + containerWidth +'; height:' + containerHeight + '; top:' + containerTopOffset + '; left:' + containerLeftOffset + '; margin-left:' + containerMarginLeft + 'px; margin-top:' + containerMarginTop + 'px; line-height:' + lineHeight + '" data-text-rotation="' + textRotation + '">';
			content += '<span class="' + type + '" style="display:block; font-family:' + fontFamily + '; font-size:' + fontSize + 'px; line-height:' + lineHeight + '; font-weight:' + fontWeight + '; font-style:' + fontStyle + '; text-align:' + textAlign + '; color:' + fontColor + '; white-space:nowrap; position:absolute; ' + absoluteAttributes + '">';
			content += text;
			content += '</span>';
			content += '</div>';
		}

		that.html(content);

		if ( '' != text ) {
			printAreaContentInfo[areaId] = {
				text: text,
				fontFamily: fontFamily,
				fontSize: fontSize + 'px',
				lineHeight: lineHeight,
				fontWeight: fontWeight,
				fontStyle: fontStyle,
				textAlign: textAlign,
				color: fontColor,
				textRotation: textRotation
			};

		} else {
			printAreaContentInfo[areaId] = {};
		}
	});
}



/**
 * Allinea correttamente il testo all'interno dell'area di stampa.
 *
 * @param {string} textAlign : allineamento del testo
 * @param {object} ctx       : contesto
 *
 * @since 1.0.0
 */
function alignText(textAlign, ctx) {
	switch ( textAlign ) {
		case 'left':
			jQuery('.print-area-content span', ctx).css('right', 'auto').css('left', 0).css('transform', 'translateY(-50%) translateX(0%)');
			break;
		case 'center':
			jQuery('.print-area-content span', ctx).css('right', 'auto').css('left', '50%').css('transform', 'translateY(-50%) translateX(-50%)');
			break;
		case 'right':
			jQuery('.print-area-content span', ctx).css('left', 'auto').css('right', 0).css('transform', 'translateY(-50%) translateX(0%)');
			break;
	}
}
